<section class="modern-cta section-spacing">
  <div class="modern-cta__inner">
    <div class="modern-cta__card" [style.--modern-cta-bottom-glow]="bottomGlow">
      <div class="modern-cta__content">
        @if (badgeLabel) {
          <span class="modern-cta__badge">
            <img
              class="modern-cta__badge-icon"
              src="/assets/img/icons/ai-stars.svg"
              alt=""
              aria-hidden="true"
            />
            {{ badgeLabel }}
          </span>
        }

        <h2 class="modern-cta__heading">{{ heading }}</h2>

        @if (description) {
          <p class="modern-cta__description">{{ description }}</p>
        }

        <div class="modern-cta__actions">
          <a
            class="modern-cta__button modern-cta__button--secondary"
            [routerLink]="secondaryLink"
            [queryParams]="secondaryQueryParams"
          >
            {{ secondaryLabel }}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M3.33203 8H12.6654"
                stroke="currentColor"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 3.33203L12.6667 7.9987L8 12.6654"
                stroke="currentColor"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </div>

        @if (tags.length) {
          <div class="modern-cta__tags">
            @for (tag of tags; track tag) {
              <span class="modern-cta__tag">{{ tag }}</span>
            }
          </div>
        }
      </div>
    </div>
  </div>
</section>
